'use client'

import { motion } from "framer-motion";
import { useSearchParams } from "next/navigation";
import { Suspense } from "react";

function ScanQRCodeComponent({ countdown, __isMobile = false }) {
    const searchParams = useSearchParams();
    const guestName = searchParams.get("tamu");
    
    const weddingDate = new Date(countdown || "2025-09-13T10:00:00");

    // Dapatkan tanggal hari ini dan atur jamnya ke 00:00
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Dapatkan tanggal pernikahan dan atur jamnya ke 00:00
    const checkinDate = new Date(weddingDate);
    checkinDate.setHours(0, 0, 0, 0);

    // Tentukan apakah check-in sudah bisa dilakukan
    const isAllowed = today >= checkinDate;

    const fadeInUp = {
        hidden: { opacity: 0, y: 40 },
        show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    };

    const titleClass = __isMobile ? "text-3xl" : "text-3xl md:text-4xl";
    const greetingName = guestName || "Guest";

    return (
        <div className="relative w-full h-auto">
            <motion.div
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
                variants={fadeInUp}
                className="relative z-50 text-center flex items-center justify-center h-full w-full"
            >
                <section className="py-12 px-8 text-center bg-white/25 backdrop-blur-md border border-white">
                    <p className={`font-semibold font-cormorant mb-4 text-white ${titleClass}`}>Scan QR Code</p>
                    <h2 className="text-2xl mb-4 text-white">Selamat datang, {greetingName}!</h2>
                    <p className="mb-6 text-white">
                        Silakan lakukan check-in dengan memindai QR code yang tersedia di lokasi acara.
                    </p>
                    {/* <button
                        onClick={handleCheckin}
                        disabled={!isAllowed}
                        className={`py-3 px-8 rounded-full font-semibold text-lg transition-colors duration-300 border border-white font-cormorant ${isAllowed ? 'bg-white text-black' : 'bg-gray-400 text-gray-700 cursor-not-allowed'}`}
                    >
                        Mulai Check-in
                    </button> */}
                    <button
                        className={`py-3 px-8 rounded-full font-semibold text-lg transition-colors duration-300 border border-white font-cormorant bg-gray-400 text-gray-700 cursor-not-allowed`}
                    >
                        Mulai Check-in
                    </button>
                    {!isAllowed && (
                        <p className="mt-4 text-sm text-white">
                            Check-in hanya bisa dilakukan pada Hari-H pernikahan.
                        </p>
                    )}
                </section>
            </motion.div>
        </div>
    );
}

export default function ScanQRCode({ countdown, __isMobile = false }) {
    return (
        <Suspense>
            <ScanQRCodeComponent countdown={countdown} __isMobile={__isMobile} />
        </Suspense>
    )
}
